import React, { useState } from "react";
import "./ChangePassword.css";
import { Button, Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { ChangePasswordPost } from "../../../../utils/apis/Login/index";
import { HTTPS } from "../../../../utils/common";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import ModalSave from "../Successfull_Modal/ModelSave";
import Modal_Heading from "../../Modal_Heading/Modal_Heading";

const PASSWORD_FIELDS = [
  {
    name: "old_password",
    label: "Old Password",
    placeholder: "Enter old password",
    rules: () => ({ required: "Old password is required" }),
  },
  {
    name: "password",
    label: "New Password",
    placeholder: "Enter new password",
    rules: () => ({
      required: "New password is required",
      minLength: {
        value: 6,
        message: "Password must be at least 6 characters",
      },
    }),
  },
  {
    name: "confirm_password",
    label: "Confirm Password",
    placeholder: "Confirm new password",
    rules: (password) => ({
      required: "Confirm password is required",
      validate: (value) => value === password || "Passwords do not match",
    }),
  },
];

function ChangePassword(props) {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setError,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      old_password: "",
      password: "",
      confirm_password: "",
    },
  });

  const password = watch("password");

  // Success modal state
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [visible, setVisible] = useState({});
  const toggleVisible = (name) =>
    setVisible((prev) => ({ ...prev, [name]: !prev[name] }));

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("old_password", data.old_password);
      sendData.append("password", data.password);
      sendData.append("confirm_password", data.confirm_password);

      const response = await ChangePasswordPost(sendData);

      if (response?.data?.code === HTTPS.OK.code) {
        // Close change password modal
        props.onHide();

        // Reset form
        reset();

        // Show success modal
        setShowModal({
          code: response?.data?.code || HTTPS.CREATED.code,
          message: response?.data?.message || "Password changed successfully!",
        });
        setTimeout(() => {
          setShowModal({ code: 0, message: "" });
          props.onHide();
          reset();
        }, 2000);
      } else {
        setError("root", {
          type: "manual",
          message:
            response?.data?.errors ||
            response?.data?.message ||
            "Something went wrong",
        });
      }
    } catch (error) {
      console.error("Change Password Error:", error);

      setError("root", {
        type: "manual",
        message:
          error?.response?.data?.errors ||
          error?.response?.data?.message ||
          "An error occurred",
      });
    }
  };

  const handleClose = () => {
    reset();
    props.onHide();
  };

  // Close success modal
  const handleSuccessClose = () => {
    setShowModal({
      code: 0,
      message: "",
    });
  };

  return (
    <section>
      {/* Change Password Modal */}
      <Modal
        {...props}
        className="Edit_User_Modal modal_holder ChangePassword_Modal"
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={handleClose}>
        <Modal_Heading modalHeading={"Change Password"} />
        <div className="modal-body-holder">
          <Modal.Body>
            <div className="main-form-holder">
              <Form className="form-holder" onSubmit={handleSubmit(onSubmit)}>
                {/* API Error */}
                {errors.root?.message && (
                  <div className="alert alert-danger">{errors.root.message}</div>
                )}

                <div className="row">
                  {PASSWORD_FIELDS.map((field) => (
                    <div className="col-md-12 col-sm-12" key={field.name}>
                      <Form.Group className="form-field">
                        <Form.Label>{field.label}*</Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            type={visible[field.name] ? "text" : "password"}
                            placeholder={field.placeholder}
                            className={classNames("no-error-icon", {
                              "is-invalid": errors?.[field.name],
                            })}
                            {...register(field.name, field.rules(password))}
                          />
                          <span
                            className="password-toggle"
                            onClick={() => toggleVisible(field.name)}>
                            {visible[field.name] ? <FaEyeSlash /> : <FaEye />}
                          </span>
                        </div>
                        {errors[field.name] && (
                          <span className="text-danger">
                            {errors[field.name].message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  ))}
                </div>
              </Form>

              <div className="modal-footer-holder">
                <div className="d-flex justify-content-center align-items-center">
                  <Button
                    className="search-btn mx-2"
                    onClick={handleClose}
                    disabled={isSubmitting}>
                    Cancel
                  </Button>

                  <Button
                    className="reset-btn mx-2"
                    type="button"
                    onClick={handleSubmit(onSubmit)}
                    disabled={isSubmitting}>
                    {isSubmitting ? "Changing..." : "Submit"}
                  </Button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </div>
      </Modal>

      {/* Success Modal */}
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code !== 0}
      />
    </section>
  );
}

export default ChangePassword;
